import Select, { SingleValue } from 'react-select';
import { hooks as commonHooks } from '@sitebuilder/common';
import { View } from './utils';

interface PropsShape {
    options: View[];
    selected: string;
    onChange: (selectedOption: string) => void;
    dataContext: any;
}

export default function ViewDropdown(props: PropsShape) {
    const i18n = commonHooks.useLocalization();

    const labelId = 'dropdown-view-label';
    const labelText = i18n.translate('widgets.fundList.viewDropdown.label');

    const handleChange = (selectedOption: SingleValue<View>) => {
        if (selectedOption) {
            props.onChange(selectedOption.id);
        }
    };

    const options: View[] = props.options.map((o) => ({
        ...o,
        label: i18n.format(o.label, props.dataContext),
    }));

    return (
        <div className="view-dropdown-wrapper">
            <label id={labelId}>{i18n.format(labelText, props.dataContext)}</label>
            <Select
                className="view-dropdown"
                aria-labelledby={labelId}
                onChange={handleChange}
                options={options}
                styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    option: (provided) => ({ ...provided, backgroundColor: '#fff', color: '#000' }),
                    control: (provided) => ({
                        ...provided,
                        borderColor: '#fff',
                        boxShadow: '#fff',
                    }),
                }}
                value={options.find((o) => o.id === props.selected)}
            />
        </div>
    );
}
